// material-ui
import { Theme, TypographyVariantsOptions } from "@mui/material/styles";

// types
import { FontFamily, ThemeMode } from "@ob/mantis/types/config";

// ==============================|| DEFAULT THEME - TYPOGRAPHY ||============================== //

const Typography = (
  mode: ThemeMode,
  fontFamily: FontFamily,
  theme: Theme,
): TypographyVariantsOptions => ({
  htmlFontSize: 16,
  fontFamily,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontFamily: "'CircularRegular', sans-serif",
    fontWeight: 600,
    fontSize: "32px",
    lineHeight: 1.21,
  },
  h2: {
    fontFamily: "'CircularRegular', sans-serif",
    fontWeight: 600,
    fontSize: "30px",
    lineHeight: 1.27,
  },
  h3: {
    fontFamily: "'CircularRegular', sans-serif",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: 1.33,
  },
  h4: {
    fontFamily: "'CircularRegular', sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: 1.4,
  },
  h5: {
    fontFamily: "'CircularRegular', sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: 1.5,
  },
  h6: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: 1.57,
  },
  caption: {
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: 1.66,
  },
  body1: {
    fontSize: "16px",
    lineHeight: 1.57,
  },
  body2: {
    fontSize: "14px",
    lineHeight: 1.66,
  },
  subtitle1: {
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: 1.57,
  },
  subtitle2: {
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: 1.66,
  },
  overline: {
    lineHeight: 1.66,
  },
  button: {
    textTransform: "capitalize",
  },
});

export default Typography;
